export default __webpack_public_path__ + "media/images/banners/months/bnr_7-75cf75bbf12895d874f79b76ba5ed0dd.jpg";